export default Vue => {
  Vue.component("v-tracking", () => import("./v-tracking.vue"));
};
